import FocusTrap from 'focus-trap-react';
import { Form, Formik } from 'formik';
import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../lib/utils/css';

import { FormCssId, FormThemes } from './constants';

import './FormWrapper.scss';

/**
 * @param  {string} theme - Theme (DEFAULT | DARK_BACKGROUND)
 * @param  {object} initialValues - Inputs' initial value
 * @param  {object} validationSchema - Inputs' necessary validation
 * @param  {Func} onSubmit - Form Submit
 * @param  {Any} children - Children that will be wrapped in 'Form__row'
 * @param  {object} debugNode - FormDebug
 */

class FormWrapper extends React.Component {
  static propTypes = {
    theme: PropTypes.oneOf(values(FormThemes)),
    initialValues: PropTypes.object,
    validationSchema: PropTypes.object,
    onSubmit: PropTypes.func,
    children: PropTypes.any,
    debugNode: PropTypes.node,
    serverError: PropTypes.string,
    errorInput: PropTypes.string,
    isInitialValid: PropTypes.func,
  };

  renderFormRows = () => {
    const { theme, children } = this.props;
    const formRows = React.Children.map(children, (child, index) => {
      return <div className='Form__row'>{React.cloneElement(child, { index, theme })}</div>;
    });
    return formRows;
  };

  renderFocusTrappedForm = formClasses => {
    const focusTrapOptions = {
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
    };
    return (
      <FocusTrap focusTrapOptions={focusTrapOptions}>
        <Form className={formClasses} id={FormCssId}>
          {this.renderFormRows()}
          {this.renderError()}
        </Form>
      </FocusTrap>
    );
  };

  renderFormWithDebug = formClasses => {
    return (
      <Form className={formClasses} id={FormCssId}>
        {this.renderFormRows()}
        {this.renderError()}
        {this.props.debugNode}
      </Form>
    );
  };

  renderError = () => {
    return (
      <div aria-live='polite'>
        {this.props.serverError && (
          <div className='Form--serverError' id={this.props.errorInput}>
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
            <p tabIndex={0}>{this.props.serverError}</p>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { theme, initialValues, validationSchema, onSubmit, isInitialValid } = this.props;
    const formClasses = createBEM('Form', {
      [theme]: !!theme,
    });
    return (
      <div>
        <Formik
          isInitialValid={isInitialValid ? isInitialValid : false}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          render={formikProps => {
            return this.props.debugNode
              ? this.renderFormWithDebug(formClasses)
              : this.renderFocusTrappedForm(formClasses);
          }}
        />
      </div>
    );
  }
}

export default FormWrapper;
